var map = {
	"./chart.png": 4181,
	"./code.png": 6074,
	"./compliance.png": 9008,
	"./infinity.png": 6177,
	"./person-star.png": 8997,
	"./search_magnify.png": 9393,
	"./settings.png": 9746,
	"./user-security.png": 7805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1957;